module.exports = __webpack_public_path__ + "static/img/incofin-logo.52a991d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/content-layout/assets/img/incofin-logo.svg
// module id = Cb4t
// module chunks = 95